/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {MutationTree} from 'vuex';
import {MessageInterface, MessageStateInterface} from '@/store/modules/message/types';
import {Vue} from 'vue-property-decorator';

export const mutations: MutationTree<MessageStateInterface> = {

    /**
     * Set the messages.
     *
     * @param {MessageStateInterface} state
     * @param {MessageInterface[]} newMessages
     */
    updateMessages(state: MessageStateInterface, newMessages: MessageInterface[]): void {
        Vue.set(state, 'messages', newMessages);
    },

};
